import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col overflow-hidden bg-white',
    closeButton: 'link flex items-center gap-2 px-6 pt-4',
    closeButtonIcon: 'rotate-180'
  },
  defaultVariants: {}
});
